import { render, staticRenderFns } from "./MedicationTableHeader.vue?vue&type=template&id=30a587d2&scoped=true"
import script from "./MedicationTableHeader.vue?vue&type=script&lang=js"
export * from "./MedicationTableHeader.vue?vue&type=script&lang=js"
import style0 from "./MedicationTableHeader.vue?vue&type=style&index=0&id=30a587d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a587d2",
  null
  
)

export default component.exports